interface IForgotPasswordData {
    email: string;
}

export const NewForgotPasswordData: IForgotPasswordData = { email: "" };

export default IForgotPasswordData;
